import { render } from "./OrderNotify.vue?vue&type=template&id=30d25868&scoped=true"
import script from "./OrderNotify.vue?vue&type=script&lang=js"
export * from "./OrderNotify.vue?vue&type=script&lang=js"

import "./OrderNotify.vue?vue&type=style&index=0&id=30d25868&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30d25868"]])

export default __exports__